import axios from 'axios';
import Vue from 'vue'

export default {

    getCountries () {
        return axios.get('/api/countries/list')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCities (countryId) {
        return axios.get('/api/countries/cities', { params: { countryId: countryId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    
    getTunisiaCities () {
        return axios.get('/api/countries/tunisie/cities')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}

